/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Certainty } from "./Certainty";
export const Metadata = core.serialization.object({
    certainty: Certainty.optional(),
    confidence: core.serialization.number().optional(),
    source: core.serialization.string().optional(),
    detectedDelimiter: core.serialization.string().optional(),
});
